import * as React from "react";

const ReverseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    className="svg-inline--fa fa-dove fa-w-16 fa-s"
    viewBox="0 0 100 100"
  >
    <path
      id="svg_4"
      fill="#fff"
      d="M83.805 23.628 59.285 7.509a3.214 2.591 0 0 0-5.239 1.995v8.008C30.394 19.533 21.91 36.533 21.91 50.968a3.214 2.591 0 0 0 2.25 2.591 3.214 2.591 0 0 0 .964 0 3.214 2.591 0 0 0 2.635-1.14s10.22-11.973 26.287-14.072v11.805l29.759-18.49a6.427 5.183 0 0 0 0-8.034"
    ></path>
    <path
      id="svg_3"
      fill="#fff"
      d="m76.178 64.032-24.52-16.12a3.214 2.591 0 0 0-5.239 1.996v8.008c-23.652 2.021-32.136 19.021-32.136 33.456a3.214 2.591 0 0 0 2.25 2.59 3.214 2.591 0 0 0 .963 0 3.214 2.591 0 0 0 2.635-1.14s10.22-11.972 26.288-14.07v11.804l29.759-18.49a6.427 5.183 0 0 0 0-8.034"
      transform="rotate(180 46.411 70.663)"
    ></path>
  </svg>
);

export default ReverseIcon;